import React, { useEffect, useRef } from 'react'

const SCROLLBAR_DISPLAY_TIME = 300
const SCROLLING_CLASS_NAME = `auto-scrolling`

interface ReturnType {
   className: string
   ref: React.RefObject<HTMLDivElement>
}

export const useAutoScrolling = (): ReturnType => {
   const containerRef = useRef<HTMLDivElement>(null)
   const timerIdRef = useRef<NodeJS.Timeout>()

   const containerClassName = `${SCROLLING_CLASS_NAME}-container`

   useEffect(() => {
      const containerEl = containerRef.current
      if (!containerEl) return

      containerEl.addEventListener('scroll', handleScrollbarStyles, true)

      return () => {
         containerEl.removeEventListener('scroll', handleScrollbarStyles, true)
      }
   }, [])

   const handleScrollbarStyles = (): void => {
      const containerEl = containerRef.current
      if (!containerEl) return

      if (!containerEl.classList.contains(SCROLLING_CLASS_NAME)) {
         containerEl.classList.add(SCROLLING_CLASS_NAME)
      }

      if (timerIdRef.current) clearTimeout(timerIdRef.current)
      timerIdRef.current = setTimeout(() => {
         if (containerEl.classList.contains(SCROLLING_CLASS_NAME)) {
            containerEl.classList.remove(SCROLLING_CLASS_NAME)
         }
      }, SCROLLBAR_DISPLAY_TIME)
   }

   return { className: containerClassName, ref: containerRef }
}
